import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "../components/Button";
import useForm from "../../hooks/useForm";
import Flex from "../components/Flex";
import { Text1Css, Text2Css } from "../components/Typography";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Input2 from "../components/Input2";
import {
  API_ENDPOINT,
  LOGIN_FORM_VALIDATION_SCHEMA,
  LOGIN_WITH_PHONE_FORM_VALIDATION_SCHEMA,
} from "../../utils/constants";
import { APIError, FetchResponse, FormFields } from "../../utils/types";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Toast from "../components/Toast";
import moment from "moment";

function LoginPage2() {
  const history = useHistory();
  const location = useLocation<any>();
  const [loginType, setLoginType] = useState<any>(true);
  const [otpPage, setOtpPage] = useState<any>(true);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [toastText, setToastText] = useState<string>("");
  const textValue = location.state?.response;
  const existEmail = location.state?.existEmail;
  
  // Get current query parameters to preserve them when navigating
  const currentSearch = location.search;
  
  // Check if oauth_flow is enabled
  const urlSearchParams = new URLSearchParams(location.search);
  const oauthFlow = urlSearchParams.get('oauth_flow');
  const isOAuthFlow = oauthFlow === '1' || oauthFlow === 'true';

  const setToast = (success: boolean) => {
    setToastText(
      `${
        success
          ? "Email already exists"
          : "The email already exists, Please login with correct password"
      }.`
    );
    setSuccess(success);
    setShowToast(true);
  };

  async function apiAuth() {
    try {
      console.log("API_ENDPOINT", API_ENDPOINT);
      const resp = await axios.get<FetchResponse<{ message: string }>>(
        API_ENDPOINT + "/me"
      );
      if (resp?.data?.success) {
        console.log("resp", resp);
        history.push({
          pathname: "/",
        });
      }
    } catch (err) {
      console.log("error");
    }
  }

  useEffect(() => {
    if (isOAuthFlow) {
      return;
    }
    apiAuth();
  }, []);

  useEffect(() => {
    existEmail && !textValue && setToast(textValue);
  }, [textValue]);

  return (
    <RightBanner $isOAuthFlow={isOAuthFlow}>
      <Heading $isOAuthFlow={isOAuthFlow}>Sign In</Heading>
      <Text>
        Not a member?{" "}
        <Span $isOAuthFlow={isOAuthFlow}>
          {" "}
          <Link to={`/register${currentSearch}`}>Register Now</Link>{" "}
        </Span>
      </Text>
      {/* <div style={{ display: "flex", marginTop: "30px", marginBottom: "30px" }}>
        <Button1
          className={loginType && "active"}
          style={{ marginRight: "30px" }}
          onClick={() => {
            setLoginType(true);
          }}
        >
          Email
        </Button1>
        <Button1
          // @ts-ignore
          className={loginType === false && "active"}
          onClick={() => setLoginType(false)}
          style={{ display: "none" }}
        >
          Phone Number
        </Button1>
      </div> */}

      {loginType ? (
        <LoginWithEmail isOAuthFlow={isOAuthFlow} />
      ) : (
        <LoginWithPhone setOtpPage={setOtpPage} isOAuthFlow={isOAuthFlow} />
      )}

      {showToast && (
        <Toast
          onClose={(showToast: any) => setShowToast(showToast)}
          success={success}
        >
          {toastText}
        </Toast>
      )}
      {!isOAuthFlow && (
        <Foot>
          <Text>© 2026, Stride Ahead</Text>
        </Foot>
      )}
    </RightBanner>
  );
}

export default LoginPage2;

// @ts-ignore
function LoginWithEmail({ isOAuthFlow }) {
  const history = useHistory();
  const location = useLocation<any>();
  const [isLoading, setLoading] = useState(false);
  const [alertStyle, setAlertStyle] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [messages, setMessages] = useState<any>({ type: "", message: "" });
  const existEmail = location.state?.existEmail;

  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [unverifiedEmail, setUnverifiedEmail] = useState<string>("");
  const [loginMethod, setLoginMethod] = useState<'password' | 'otp'>('password');
  const [otpEmail, setOtpEmail] = useState<string>("");
  const [showOtpLogin, setShowOtpLogin] = useState(false);
  
  const urlSearchParams = new URLSearchParams(location.search);

  const actionOnSubmit = async (data: {
    [key in FormFields]?: string;
  }): Promise<APIError[] | void> => {
    console.log("hello");
    setLoading(true);
    console.log(data);
    try {
      const resp = await axios.post<FetchResponse<{ message: string }>>(
        API_ENDPOINT + "/login",
        data
      );
      const re: any = resp.data;
      console.log("re", re);
      setMessages({
        type: "success",
        message: re?.data?.message,
      });
      setLoading(false);
      const urlSearchParams = new URLSearchParams(history.location.search);
      const redirectUrl = urlSearchParams.get("redirect_to");
      // A malformed redirect_to must not turn a successful login into an
      // error state, so URL parsing failures fall back to the dashboard.
      let redirectTo: URL | null = null;
      if (redirectUrl !== null) {
        try {
          redirectTo = new URL(decodeURIComponent(redirectUrl));
        } catch {
          redirectTo = null;
        }
      }
      if (redirectTo) {
        window.location.href = redirectTo.href;
      } else {
        history.push({
          pathname: "/",
          state: { response: true, message: "logged in successfully" },
        });
      }
    } catch (error: any) {
      console.log(
        "actionOnSubmit::error",
        error.response?.data?.error
      );
      
      // Check if email is not verified
      // Error is wrapped in an array by BaseResponse
      const errorObj = Array.isArray(error.response?.data?.error) 
        ? error.response?.data?.error[0] 
        : error.response?.data?.error;
      
      if (errorObj?.email_not_verified) {
        // Redirect to separate email verification page for login
        const emailToVerify = errorObj?.email || data.email;
        const urlSearchParams = new URLSearchParams(history.location.search);
        const redirectUrl = urlSearchParams.get("redirect_to");
        const oauthFlow = urlSearchParams.get("oauth_flow");
        
        history.push({
          pathname: "/email_otp_verification_login",
          search: `?email=${encodeURIComponent(emailToVerify)}${redirectUrl ? `&redirect_to=${encodeURIComponent(redirectUrl)}` : ''}${oauthFlow ? `&oauth_flow=${oauthFlow}` : ''}&mode=login`,
          state: {
            email: emailToVerify,
            password: data.password,
            mode: 'login'
          }
        });
      } else {
        setMessages({
          type: "error",
          message: `${errorObj?.form_level_error || error.response?.data?.message || "Login failed"}`,
        });
      }
      setLoading(false);
      const errors = error.response?.data?.error as APIError[];
      return errors;
    }
  };

  const handleVerifySuccess = (response: any) => {
    // After OTP verification, check if refresh_token is returned (user is logged in)
    if (response?.data?.refresh_token) {
      setMessages({
        type: "success",
        message: "Logged in successfully",
      });
      
      const urlSearchParams = new URLSearchParams(history.location.search);
      const redirectUrl: any = urlSearchParams.get("redirect_to");
      if (redirectUrl !== null) {
        try {
          const redirectTo = new URL(decodeURIComponent(redirectUrl));
          window.location.href = redirectTo.href;
        } catch (e) {
          history.push({
            pathname: "/",
            state: { response: true, message: "logged in successfully" },
          });
        }
      } else {
        history.push({
          pathname: "/",
          state: { response: true, message: "logged in successfully" },
        });
      }
    } else {
      // OTP verified but no token - try password login for unverified email scenario
      if (formData.password?.value) {
        axios.post<FetchResponse<{ message: string }>>(
          API_ENDPOINT + "/login",
          { email: unverifiedEmail, password: formData.password?.value }
        ).then(() => {
          setMessages({
            type: "success",
            message: "Email verified and logged in successfully",
          });
          
          const urlSearchParams = new URLSearchParams(history.location.search);
          const redirectUrl: any = urlSearchParams.get("redirect_to");
          if (redirectUrl !== null) {
            try {
              const redirectTo = new URL(decodeURIComponent(redirectUrl));
              window.location.href = redirectTo.href;
            } catch (e) {
              history.push({
                pathname: "/",
                state: { response: true, message: "logged in successfully" },
              });
            }
          } else {
            history.push({
              pathname: "/",
              state: { response: true, message: "logged in successfully" },
            });
          }
        }).catch((error: any) => {
          setMessages({
            type: "error",
            message: `${error.response?.data?.error?.[0]?.form_level_error || "Login failed after verification"}`,
          });
        });
      }
    }
  };

  const handleOtpLoginSuccess = (response: any) => {
    // OTP login successful - user is already logged in via OTP verification
    if (response?.data?.refresh_token) {
      setMessages({
        type: "success",
        message: "Logged in successfully",
      });
      
      const urlSearchParams = new URLSearchParams(history.location.search);
      const redirectUrl: any = urlSearchParams.get("redirect_to");
      if (redirectUrl !== null) {
        try {
          const redirectTo = new URL(decodeURIComponent(redirectUrl));
          window.location.href = redirectTo.href;
        } catch (e) {
          history.push({
            pathname: "/",
            state: { response: true, message: "logged in successfully" },
          });
        }
      } else {
        history.push({
          pathname: "/",
          state: { response: true, message: "logged in successfully" },
        });
      }
    }
  };

  const {
    formData,
    setFormData,
    formSubmitResponse,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useForm({
    actions: { onSubmit: actionOnSubmit },
    validatorSchema: LOGIN_FORM_VALIDATION_SCHEMA,
    handleValidationOnBlur: true,
  });

  const handleForgotPassword = () => {
    const urlSearchParams = new URLSearchParams(history.location.search);
    const redirectUrl = urlSearchParams.get("redirect_to");
    const path = redirectUrl 
      ? `/forget_password?redirect_to=${encodeURIComponent(redirectUrl)}`
      : "/forget_password";
    history.push(path);
  };

  useEffect(() => {
    existEmail &&
      setFormData({
        ...formData,
        email: { value: existEmail, error: "" },
      });
  }, [existEmail]);

  const isButtonDisabled = () => {
    return !(
      formData.email?.value !== "" &&
      formData.email?.error === "" &&
      formData.password?.value !== "" &&
      formData.password?.error === "" &&
      !isLoading
    );
  };

  useEffect(() => {
    messages.message ? setShowAlert(true) : setShowAlert(false);
  }, [messages]);

  useEffect(() => {
    messages?.type === "success" ? setAlertStyle(true) : setAlertStyle(false);
  }, [messages]);


  const handleSendSignInCode = async () => {
    if (!otpEmail || !/^\S+@\S+\.\S+$/.test(otpEmail)) {
      setMessages({
        type: "error",
        message: "Please enter a valid email address.",
      });
      return;
    }

    setLoading(true);
    try {
      // Send OTP first
      const urlSearchParams = new URLSearchParams(history.location.search);
      const redirectUrl = urlSearchParams.get("redirect_to");
      let url = API_ENDPOINT + "/otp";
      if (redirectUrl) {
        url += `?redirect_to=${encodeURIComponent(redirectUrl)}`;
      }

      await axios.post<FetchResponse<{ message: string }>>(
        url,
        { email: otpEmail, mode: 'login_otp' }
      );

      // After OTP is sent successfully, redirect to verification page
      const oauthFlow = urlSearchParams.get("oauth_flow");
      history.push({
        pathname: "/email_otp_verification_login",
        search: `?email=${encodeURIComponent(otpEmail)}${redirectUrl ? `&redirect_to=${encodeURIComponent(redirectUrl)}` : ''}${oauthFlow ? `&oauth_flow=${oauthFlow}` : ''}&mode=login_otp`,
        state: {
          email: otpEmail,
          mode: 'login_otp',
          otpAlreadySent: true // Mark that OTP was already sent
        }
      });
    } catch (error: any) {
      setLoading(false);
      let errorMessage = "Failed to send sign-in code. Please try again.";

      if (error.response?.status === 404) {
        errorMessage = error.response?.data?.message || "User with this email does not exist.";
      } else if (error.response?.status === 429) {
        errorMessage = error.response?.data?.message || "Too many requests. Please wait before requesting a new code.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      setMessages({
        type: "error",
        message: errorMessage,
      });
    }
  };

  // One <form> serves several modes, so submission has to be routed by the mode
  // that is currently on screen. Without this, pressing Enter in the sign-in-code
  // email field implicitly submits the form and runs the password-login action
  // with an empty password, which fails with a generic error.
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (showEmailVerification) {
      e.preventDefault();
      return;
    }
    if (showOtpLogin) {
      e.preventDefault();
      void handleSendSignInCode();
      return;
    }
    handleSubmit(e);
  };

  const handleOtpMethodClick = () => {
    setLoginMethod('otp');
    setShowOtpLogin(true);
    setMessages({ type: "", message: "" });
  };

  const handlePasswordMethodClick = () => {
    setLoginMethod('password');
    setShowOtpLogin(false);
    setOtpEmail("");
    setMessages({ type: "", message: "" });
  };

  return (
    <form onSubmit={handleFormSubmit}>
      {/* Shared alert for both methods; switching methods clears messages */}
      {showAlert && !showEmailVerification && (
        <div
          className={alertStyle ? "alert alert-success " : "alert alert-danger"}
          role="alert"
        >
          {messages?.message}
        </div>
      )}
      
      {/* Email sign-in code button - shown only on password login form */}
      {!showEmailVerification && !showOtpLogin && (
        <>
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <OtpLoginButton
              type="button"
              onClick={handleOtpMethodClick}
            >
              Email sign-in code
            </OtpLoginButton>
          </div>

          <MethodDivider align="center">
            <span className="line" />
            <span className="label">or sign in with password</span>
            <span className="line" />
          </MethodDivider>
        </>
      )}

      {showOtpLogin ? (
        <div style={{ marginTop: "30px" }}>
          <div style={{ marginBottom: "20px" }}>
            <StyleInput
              type="email"
              name="otpEmail"
              label="Email Address"
              placeholder="Enter Your Email Address"
              value={otpEmail}
              error=""
              required
              autoFocus
              onChange={(e: any) => setOtpEmail(e.target.value)}
              onBlur={() => {}}
              showSuccessIndicator={false}
            />
          </div>
          <StyledButton
            type="submit"
            disabled={!otpEmail || isLoading}
            isLoading={isLoading}
          >
            Send Sign-in Code
          </StyledButton>
          <MethodDivider align="center" style={{ marginTop: "24px" }}>
            <span className="line" />
            <span className="label">or</span>
            <span className="line" />
          </MethodDivider>

          <div style={{ marginTop: "16px", textAlign: "center" }}>
            <BackToPassword onClick={handlePasswordMethodClick}>
              ← Back to password login
            </BackToPassword>
          </div>
        </div>
      ) : !showEmailVerification ? (
        <>
          <div style={{ marginTop: "30px" }}>
            <StyleInput
              type="email"
              name="email"
              label="Email Address"
              placeholder="Enter Your Email Address"
              value={formData.email?.value}
              error={formData.email?.error}
              required
              autoFocus
              onChange={handleChange}
              onBlur={handleBlur}
              showSuccessIndicator={false}
            />

            <StyleInput
              type="password"
              name="password"
              label="Password"
              placeholder="Enter Your Password"
              value={formData.password?.value}
              error={formData.password?.error}
              required
              onChange={handleChange}
              onBlur={handleBlur}
              showSuccessIndicator={false}
            />
          </div>
          <Flex justify="flex-end">
            <ForgotPassword onClick={handleForgotPassword}>
              Forgot Password?
            </ForgotPassword>
          </Flex>
          <StyledButton
            type="submit"
            disabled={isButtonDisabled()}
            isLoading={isLoading}
          >
            Sign In
          </StyledButton>
        </>
      ) : null}
    </form>
  );
}

// @ts-ignore
function LoginWithPhone({ setOtpPage, isOAuthFlow }) {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [phone, setPhone] = useState<string>();
  const [alertStyle, setAlertStyle] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [messages, setMessages] = useState<any>({ type: "", message: "" });

  const actionOnSubmit = async (data: {
    [key in FormFields]?: string;
  }): Promise<APIError[] | void> => {
    setLoading(true);
    try {
      const resp = await axios.post<FetchResponse<{ message: string }>>(
        API_ENDPOINT + "/otp",
        { phone_number: `+${phone}` }
      );
      const re: any = resp?.data;
      console.log(re?.data);
      const dateString = new Date(re?.data?.expiry_time);
      const dateString2 = Date.now();
      console.log(dateString);
      console.log(dateString2);
      const date = moment(dateString);
      const timestamp = date.valueOf();
      const date2 = moment(dateString2);
      const timestamp2 = date2.valueOf();
      const min = (timestamp2 - timestamp) / 1000 / 60;
      setMessages({
        type: "success",
        message: `${re?.data?.message}`,
      });
      setLoading(false);
      history.push({
        pathname: "/email_otp_verification",
        search: history.location.search,
        state: { phone_number: phone, expiryTime: min, response: true },
      });
      setOtpPage(false);
    } catch (error: any) {
      console.log("actionOnSubmit::error", error);
      setMessages({
        type: "error",
        message: `${
          error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error[0]?.phone_number
        }`,
      });
      setLoading(false);
      const errors = error.response?.data?.error as APIError[];
      return errors;
    }
  };

  const { handleSubmit } = useForm({
    actions: { onSubmit: actionOnSubmit },
    validatorSchema: LOGIN_WITH_PHONE_FORM_VALIDATION_SCHEMA,
    handleValidationOnBlur: true,
  });

  const isButtonDisabled = () => {
    return phone == "" && !isLoading;
  };

  useEffect(() => {
    messages.message ? setShowAlert(true) : setShowAlert(false);
  }, [messages]);

  useEffect(() => {
    messages?.type === "success" ? setAlertStyle(true) : setAlertStyle(false);
  }, [messages]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        {showAlert && (
          <div
            className={
              alertStyle ? "alert alert-success " : "alert alert-danger"
            }
            role="alert"
          >
            {messages?.message}
          </div>
        )}
        <div style={{ marginTop: "30px" }}>
          <Label>Phone Number *</Label>
          <StyledPhoneInput
            country={"in"}
            value={phone}
            onChange={(phone) => setPhone(phone)}
          />
        </div>
        <StyledButton
          type="submit"
          disabled={isButtonDisabled()}
          isLoading={isLoading}
          // onClick={() => setOtpPage(false)}
        >
          Continue
        </StyledButton>
      </form>
    </>
  );
}

const OrContainer = styled(Flex)`
  width: 100%;
  margin-top: 40px;
  color: #93acbd;
  .line {
    display: block;
    height: 2px;
    flex-grow: 1;
    background-color: #93acbd;
  }
`;

const MethodDivider = styled(OrContainer)`
  margin-top: 0;

  .line {
    height: 1px;
    background-color: #e2e8f0;
  }

  .label {
    padding: 0 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    white-space: nowrap;
  }

  @media (max-width: 576px) {
    .label {
      padding: 0 12px;
      font-size: 12px;
    }
  }
`;

const RightBanner = styled.div<{ $isOAuthFlow?: boolean }>`
  padding: 32px 40px;
  width: 100%;
  @media (max-width: 576px) {
    padding: 20px 16px;
  }
`;
const StyledButton = styled(Button)`
  background: #3f52fd;
  border-radius: 10px;
  margin-top: 1.5rem;
  @media (max-width: 576px) {
    margin-top: 1.5rem;
    height: 50px !important;
  }
`;

const Heading = styled.h1<{ $isOAuthFlow?: boolean }>`
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: ${props => props.$isOAuthFlow ? '#333333' : '#073b5f'};
  @media (max-width: 576px) {
    font-size: 20px;
  }
`;

const Text = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #93acbd;
  margin: 0;
  @media (max-width: 576px) {
    font-size: 12px;
  }
`;

const Span = styled.span<{ $isOAuthFlow?: boolean }>`
  font-weight: 600;
  color: ${props => props.$isOAuthFlow ? '#0066cc' : '#3f52fd'};
  a {
    color: ${props => props.$isOAuthFlow ? '#0066cc' : '#3f52fd'};
    text-decoration: none;
  }
`;

const Button1 = styled.div`
  padding: 11px 32px;
  // background: rgba(18, 115, 183, 0.1);
  border: 1.2px solid rgba(18, 115, 183, 0.1);
  border-radius: 10px;
  font-size: 18px;
  color: #93acbd;
  text-decoration: none !important;
  cursor: pointer;
  @media (max-width: 576px) {
    padding: 8px 26px;
    font-size: 16px;
    // width:98px;
    // height: 42px;
    // display:grid;
    // place-items:center;
  }
`;

const Label = styled.label`
  font-weight: 400;
  font-size: 14px;
  // line-height: 21px;
  color: #93acbd;
  @media (max-width: 576px) {
    font-size: 12px;
  }
`;

const StyleInput = styled(Input2)``;

const OtpLoginButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  background: #ffffff;
  border: 2px solid #e0e7ff;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #3f52fd;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f0f4ff;
    border-color: #3f52fd;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const BackToPassword = styled.span`
  color: #3f52fd;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    text-decoration: underline;
    color: #2d3fd8;
  }
`;

const ForgotPassword = styled.span`
  ${Text1Css}
  font-weight: 600;
  color: ${({ theme }) => theme.colors.blue[500]};
  cursor: pointer;
  @media (max-width: 576px) {
    font-size: 14px;
    font-weight: 500;
  }
`;

const Foot = styled.div`
  @media (min-width: 576px) {
    display: none;
  }
  @media (max-width: 576px) {
    margin-top: 20px;
    text-align: center;
    display: block;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-top: 40px;
    text-align: center;
    display: block;
  }
`;

const StyledPhoneInput = styled(PhoneInput)`
  border: 1.2px solid #88b9db;
  border-radius: 10px;
  margin-top: 8px;
  .react-tel-input.form-control {
    padding-left: 68px !important;
  }
  .flag-dropdown {
    border: none;
    border-radius: 10px 0px 0px 10px;
    background: transparent !important;
    &::after {
      content: "";
      position: absolute;
      left: 100%;
      top: 9px;
      width: 1px;
      height: 24px;
      background: #88b9db;
    }
  }
  .selected-flag {
    width: 50px;
    border-radius: 10px 0px 0px 10px;
    &:hover {
      border-radius: 10px 0px 0px 10px;
      background: transparent !important;
    }
  }
  .open {
    border-radius: 10px !important;
  }
  .flag {
    margin: 0px !important;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .country-list {
    padding: 5px 15px;
  }

  .country {
    display: flex;
    align-items: end;
  }

  input {
    width: 100% !important;
    height: 50px !important;
    padding: 10px 0px 10px 60px !important;
    font-weight: 600;
    font-size: 16px;
    color: #3f52fd;
    background: #ffffff;
    // border-radius: 8px;
    border: none !important;
    border-radius: 10px !important;

    @media (max-width: 576px) {
      height: 42px !important;
    }

    &:focus {
      background: #e7f1f8;
      border: 1.2px solid #3f52fd;
      border-radius: 10px;
      outline: none;
      .flag-dropdown {
        background: #e7f1f8;
      }
    }
  }
`;

